import React from 'react';
import { useTranslation } from 'react-i18next';
import { HeadlineSmall } from '@shared/ui/atoms/fonts/Headline';
import { SchengenTrackingSetting } from '@shared/ui/organisms/settings/SchengenTrackingSetting';
import { BuildVersion } from '@shared/ui/organisms/settings/BuildVersion';
import { SectionSaveButton } from './SectionSaveButton';
import { McpIntegrationSetting } from '@shared/ui/organisms/settings/McpIntegrationSetting';
import { LockersSetting } from '@shared/ui/organisms/settings/LockersSetting';
import { SignageSetting } from '@shared/ui/organisms/settings/SignageSetting';
import { SignageDevicesSection } from './SignageDevicesSection';
import { IsBetaTester } from '@shared/hooks/IsBetaTester';

export function OtherPanel() {
  const { t } = useTranslation();
  const isBetaTester = IsBetaTester();
  return (
    <>
      <HeadlineSmall style={{ marginBottom: 16 }}>{t('company-settings-page.other-tab')}</HeadlineSmall>
      <SchengenTrackingSetting />
      <McpIntegrationSetting />
      {isBetaTester && <LockersSetting />}
      <SignageSetting />
      <SignageDevicesSection />
      <SectionSaveButton />
      <BuildVersion />
    </>
  );
}
